import React, { Fragment, useEffect } from 'react'
import Img1 from "../images/page.png"

const PageNotFound = () => {


    useEffect(() => {
        document.title = `PAGE NOT FOUND`;

    }, [])


    return (
        <Fragment>
            <section className="pageNotFound flex">
                <div>
                    <img src={Img1} alt="" />
                </div>
            </section>
        </Fragment>
    )
}

export default PageNotFound